import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import {
  LEGISLATION_TYPE_OPTIONS,
  type LegislationTypeCode,
} from '@artem-lex/common-server/radar/legislationTypes'

type Props = {
  selectedTypes: LegislationTypeCode[]
  onToggle: (code: LegislationTypeCode) => void
  onClear: () => void
}

export default function LegislationTypeFilter({ selectedTypes, onToggle, onClear }: Props) {
  const selectedCount = selectedTypes.length
  const triggerLabel =
    selectedCount > 0
      ? `Filter legislation type (${selectedCount} selected)`
      : 'Filter legislation type'

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type='button'
          className='flex h-9 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 py-1 text-left text-sm shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50'
        >
          <span className={selectedCount > 0 ? '' : 'text-muted-foreground'}>{triggerLabel}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align='start' className='w-[320px] p-3'>
        <div className='space-y-2'>
          {LEGISLATION_TYPE_OPTIONS.map((option) => {
            const isSelected = selectedTypes.some(
              (value) => value.toUpperCase() === option.code
            )
            return (
              <label
                key={option.code}
                className='flex cursor-pointer items-center gap-2 text-sm'
              >
                <input
                  type='checkbox'
                  checked={isSelected}
                  onChange={() => onToggle(option.code)}
                />
                <span>{option.label}</span>
              </label>
            )
          })}
        </div>
        {selectedCount > 0 ? (
          <div className='mt-3 border-t pt-2'>
            <button type='button' className='text-xs underline' onClick={onClear}>
              Clear type filters
            </button>
          </div>
        ) : null}
      </PopoverContent>
    </Popover>
  )
}
